module.exports = __webpack_public_path__ + "img/mind_background_10.62fd9b0e.png";